import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {_PRAIP_SHA} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfSurvivingTheNextYear/PRAIP_SHA'; // eslint-disable-line max-len
import {_PRACM_SHA} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfSurvivingTheNextYear/PRACM_SHA'; // eslint-disable-line max-len
import {_PRAIP_AHT} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfAvoidingHeartAttack/PRAIP_AHT'; // eslint-disable-line max-len
import {_PRACM_AHT} from '../../../equations/heartAttackBranch_Alberta(GeneralPopulation)/likelihoodOfAvoidingHeartAttack/PRACM_AHT'; // eslint-disable-line max-len
import {_PRAIP_SHA as _PRAIP_SHA_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfSurvivingTheNextYear/PRAIP_SHA'; // eslint-disable-line max-len
import {_PRACM_SHA as _PRACM_SHA_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfSurvivingTheNextYear/PRACM_SHA'; // eslint-disable-line max-len
import {_PRAIP_AHT as _PRAIP_AHT_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfAvoidingHeartAttack/PRAIP_AHT'; // eslint-disable-line max-len
import {_PRACM_AHT as _PRACM_AHT_BC} from '../../../equations/heartAttackBranch_BritishColumbia(Nephrology)/likelihoodOfAvoidingHeartAttack/PRACM_AHT'; // eslint-disable-line max-len
import benefitsInfo from '../../../../assets/images/icons/benefits_info.svg';
import benefitsSymbol from '../../../../assets/images/icons/benefits_symbol.svg';
import {Details as SurvivingHeartAttackDetails} from './SurvivingHeartAttack/details';
import {References as SurvivingHeartAttackReferences} from './SurvivingHeartAttack/references';
import {AdditionalInfo as SurvivingHeartAttackAddInfo} from './SurvivingHeartAttack/additionalInfo';
import {References as AvoidingHeartAttackReferences} from './AvoidingHeartAttack/references';
import {Details as AvoidingHeartAttackDetails} from './AvoidingHeartAttack/details';
import {AdditionalInfo as AvoidingHeartAttackAddInfo} from './AvoidingHeartAttack/additionalInfo';
import {Tooltip} from '../../common/tooltip';
import {GLOSSARY_KEYS, HEART_CONDITIONS} from '../../../containers/appConstants';
import {getFormattedResult} from '../../../utils/utils';

export const BenefitsDetails = () => {
  const healthFactors = useSelector(state => state.healthFactors);
  const dataSourceProvince = useSelector(state => state.heartCondition.dataSourceProvince);

  const [survivingHeartAttackInvasiveDetails, setSurvivingHeartAttackInvasiveDetails] = useState({});
  const [survivingHeartAttackConservativeDetails, setSurvivingHeartAttackConservativeDetails] = useState({});

  const [avoidingHeartAttackInvasiveDetails, setAvoidingHeartAttackInvasiveDetails] = useState({});
  const [avoidingHeartAttackConservativeDetails, setAvoidingHeartAttackConservativeDetails] = useState({});

  useEffect(() => {
    if (dataSourceProvince === HEART_CONDITIONS.BC_ONLY_PEOPLE_REFERRED_TO_A_NEPHROLOGIST) {
      setSurvivingHeartAttackInvasiveDetails(_PRAIP_SHA_BC(healthFactors));
      setSurvivingHeartAttackConservativeDetails(_PRACM_SHA_BC(healthFactors));
      setAvoidingHeartAttackInvasiveDetails(_PRAIP_AHT_BC(healthFactors));
      setAvoidingHeartAttackConservativeDetails(_PRACM_AHT_BC(healthFactors));
    }
    else {
      setSurvivingHeartAttackInvasiveDetails(_PRAIP_SHA(healthFactors));
      setSurvivingHeartAttackConservativeDetails(_PRACM_SHA(healthFactors));
      setAvoidingHeartAttackInvasiveDetails(_PRAIP_AHT(healthFactors));
      setAvoidingHeartAttackConservativeDetails(_PRACM_AHT(healthFactors));
    }
  }, []);

  return (
    <>
      <section className='bordered all-rounded-borders white-bg-color margin-bottom-2'>
        {
          process.env.REACT_APP_ENVIRONMENT !== 'production' &&
          <div className='grid-container'>
            <p>Values used in calculating these results (For testing only)</p>
            <table className='bordered margin-bottom-2 text-center'>
              <tr>
                <th className='bordered'>Field</th>
                <th className='bordered'>Value</th>
              </tr>
              <tr>
                <td className='bordered'>Age</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.age}</td>
              </tr>
              <tr>
                <td className='bordered'>Sex</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.sex}</td>
              </tr>
              <tr>
                <td className='bordered'>NSTEMI</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.nstemi}</td>
              </tr>
              <tr>
                <td className='bordered'>eGFR</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.eGFR}</td>
              </tr>
              <tr>
                <td className='bordered'>Hemoglobin</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.haemoglobin}</td>
              </tr>
              <tr>
                <td className='bordered'>Albuminuria Mild</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.albuminuria_mild}</td>
              </tr>
              <tr>
                <td className='bordered'>Albuminuria Heavy</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.albuminuria_heavy}</td>
              </tr>
              <tr>
                <td className='bordered'>charlson_CHF</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.charlson_CHF}</td>
              </tr>
              <tr>
                <td className='bordered'>charlson_COPD</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.charlson_COPD}</td>
              </tr>
              <tr>
                <td className='bordered'>liver_disease</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.liver_disease}</td>
              </tr>
              <tr>
                <td className='bordered'>charlson_PVD</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.charlson_PVD}</td>
              </tr>
              <tr>
                <td className='bordered'>Diabetes</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.diabetes}</td>
              </tr>
              <tr>
                <td className='bordered'>Prior Invasive</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.prior_invasive}</td>
              </tr>
              <tr>
                <td className='bordered'>S0 (Used In Equation)</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.S0}</td>
              </tr>
              <tr>
                <td className='bordered'>eGFR_c2 (Used In Equation)</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.eGFR_c2}</td>
              </tr>
              <tr>
                <td className='bordered'>EBX (Used In Equation)</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.EBX}</td>
              </tr>
              <tr>
                <td className='bordered'>Predicted Risk Invasive</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.PRI}</td>
              </tr>
              <tr>
                <td className='bordered'>Mortality Predicted Risk Invasive (1 - Predicted Risk Invasive)</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.mortality}</td>
              </tr>
              <tr>
                <td className='bordered'>Probability Predicted Risk Invasive (Mortality x 100)</td>
                <td className='bordered'>{survivingHeartAttackInvasiveDetails.probability}</td>
              </tr>
              <tr>
                <td className='bordered'>Conservative Management</td>
                <td className='bordered'>{survivingHeartAttackConservativeDetails.PRC}</td>
              </tr>
              <tr>
                <td className='bordered'>Mortality Conservative Management (1 - Conservative Management)</td>
                <td className='bordered'>{survivingHeartAttackConservativeDetails.mortality}</td>
              </tr>
              <tr>
                <td className='bordered'>Probability (Mortality x 100)</td>
                <td className='bordered'>{survivingHeartAttackConservativeDetails.probability}</td>
              </tr>
            </table>
          </div>
        }
        <div className='grid-container'>
          <div className='text-center'>
            <h2>Likelihood of surviving the next year</h2>
            <div className='grid-x medium-up-2 margin-vertical-1'>
              <div className='cell'>
                <div className='card align-center border-right'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Invasive Heart Procedure plus<br/> Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-blue margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={benefitsSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(survivingHeartAttackInvasiveDetails.probability).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(survivingHeartAttackInvasiveDetails.probability).toFixed(0))}/100)
                  </p>
                </div>
              </div>
              <div className='cell'>
                <div className='card align-center'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-blue margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={benefitsSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(survivingHeartAttackConservativeDetails.probability).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(survivingHeartAttackConservativeDetails.probability).toFixed(0))}/100)
                  </p>
                </div>
              </div>
            </div>
            <div className='grid-x align-center-middle'>
              <div className='cell shrink margin-0'>
                <img
                  alt='Icon image'
                  className='margin-right-1'
                  src={benefitsInfo}/>
              </div>
              <div className='cell auto margin-0 text-left'>
                <p className='margin-0'>
                  Treatment with an&nbsp;<Tooltip
                    id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                    title='invasive heart procedure'/>&nbsp;avoided&nbsp;<span className='benefits-text'>
                    {
                      Number(survivingHeartAttackInvasiveDetails.probability).toFixed(0) -
                      Number(survivingHeartAttackConservativeDetails.probability).toFixed(0)
                    }
                  &nbsp;deaths for every 100 patients</span>&nbsp;like you compared to&nbsp;<Tooltip
                    id={GLOSSARY_KEYS.OPTIMAL_MEDICATION_MANAGEMENT}
                    title='optimal medication management'/>.

                </p>
              </div>
            </div>
            {/* The below section is only visible on screen, not while printing */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>What does this look like?</h3>
                  </summary>
                  <SurvivingHeartAttackDetails
                    conservativeProb={Number(survivingHeartAttackConservativeDetails.probability).toFixed(0)}
                    invasiveProb={Number(survivingHeartAttackInvasiveDetails.probability).toFixed(0)}
                  />
                </details>
              </div>
            </div>
            {/* The below section is only visible while printing */}
            <div className='margin-vertical-2 show-for-print text-left'>
              <SurvivingHeartAttackDetails
                conservativeProb={Number(survivingHeartAttackConservativeDetails.probability).toFixed(0)}
                invasiveProb={Number(survivingHeartAttackInvasiveDetails.probability).toFixed(0)}
              />
              <div className='padding-horizontal-2'>
                <SurvivingHeartAttackAddInfo/>
              </div>
            </div>
            {/* The below section is only visible on screen */}
            <div className='grid-x text-left margin-vertical-1 hide-for-print'>
              <div className='cell bordered all-rounded-borders'>
                <details>
                  <summary className='padding-2'>
                    <h3 className='info-color text-uppercase'>
                      What is this information based on? (Show me the references)
                    </h3>
                  </summary>
                  <SurvivingHeartAttackReferences/>
                </details>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='bordered all-rounded-borders white-bg-color margin-bottom-2'>
        {
          process.env.REACT_APP_ENVIRONMENT !== 'production' &&
        <div className='grid-container'>
          <p>Values used in calculating these results (For testing only)</p>
          <table className='bordered margin-bottom-2 text-center'>
            <tr>
              <th className='bordered'>Field</th>
              <th className='bordered'>Value</th>
            </tr>
            <tr>
              <td className='bordered'>Age</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.age}</td>
            </tr>
            <tr>
              <td className='bordered'>Sex</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.sex}</td>
            </tr>
            <tr>
              <td className='bordered'>NSTEMI</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.nstemi}</td>
            </tr>
            <tr>
              <td className='bordered'>eGFR</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.eGFR}</td>
            </tr>
            <tr>
              <td className='bordered'>Hemoglobin</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.haemoglobin}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Mild</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.albuminuria_mild}</td>
            </tr>
            <tr>
              <td className='bordered'>Albuminuria Heavy</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.albuminuria_heavy}</td>
            </tr>
            <tr>
              <td className='bordered'>charlson_CHF</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.charlson_CHF}</td>
            </tr>
            <tr>
              <td className='bordered'>charlson_COPD</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.charlson_COPD}</td>
            </tr>
            <tr>
              <td className='bordered'>liver_disease</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.liver_disease}</td>
            </tr>
            <tr>
              <td className='bordered'>charlson_PVD</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.charlson_PVD}</td>
            </tr>
            <tr>
              <td className='bordered'>Diabetes</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.diabetes}</td>
            </tr>
            <tr>
              <td className='bordered'>Prior Invasive</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.prior_invasive}</td>
            </tr>
            <tr>
              <td className='bordered'>S0 (Used In Equation)</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.S0}</td>
            </tr>
            <tr>
              <td className='bordered'>EBX (Used In Equation)</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.EBX}</td>
            </tr>
            <tr>
              <td className='bordered'>Predicted Risk Invasive</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.PRI}</td>
            </tr>
            <tr>
              <td className='bordered'>Mortality Predicted Risk Invasive (1 - Predicted Risk Invasive)</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.mortality}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability Predicted Risk Invasive (Mortality x 100)</td>
              <td className='bordered'>{avoidingHeartAttackInvasiveDetails.probability}</td>
            </tr>
            <tr>
              <td className='bordered'>Conservative Management</td>
              <td className='bordered'>{avoidingHeartAttackConservativeDetails.PRC}</td>
            </tr>
            <tr>
              <td className='bordered'>Mortality Conservative Management (1 - Conservative Management)</td>
              <td className='bordered'>{avoidingHeartAttackConservativeDetails.mortality}</td>
            </tr>
            <tr>
              <td className='bordered'>Probability (Mortality x 100)</td>
              <td className='bordered'>{avoidingHeartAttackConservativeDetails.probability}</td>
            </tr>
          </table>
        </div>
        }
        <div className='grid-container'>
          <div className='text-center'>
            <h2>Likelihood of avoiding another heart attack in the next year</h2>
            <div className='grid-x medium-up-2 margin-vertical-1'>
              <div className='cell'>
                <div className='card align-center border-right'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Invasive Heart Procedure plus<br/> Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-blue margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={benefitsSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(avoidingHeartAttackInvasiveDetails.probability).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(avoidingHeartAttackInvasiveDetails.probability).toFixed(0))}/100)
                  </p>
                </div>
              </div>
              <div className='cell '>
                <div className='card align-center'>
                  <h4 className='margin-bottom-1 height-50-px'>
                    Optimal Medication Management
                  </h4>
                  <div className='rounded percentage-circle bg-color-blue margin-vertical-1'>
                    <div className='rounded inside-circle'>
                      <img
                        alt='Icon image'
                        src={benefitsSymbol}/>
                      <p className='margin-0'>
                        {getFormattedResult(Number(avoidingHeartAttackConservativeDetails.probability).toFixed(0))}%
                      </p>
                    </div>
                  </div>
                  <p>
                    ({getFormattedResult(Number(avoidingHeartAttackConservativeDetails.probability).toFixed(0))}/100)
                  </p>
                </div>
              </div>
            </div>
            <div className='grid-x align-center-middle'>
              <div className='cell shrink margin-0'>
                <img
                  alt='Icon image'
                  className='margin-right-1'
                  src={benefitsInfo}/>
              </div>
              <div className='cell auto margin-0 text-left'>
                <p className='margin-0'>
                  Treatment with an&nbsp;<Tooltip
                    id={GLOSSARY_KEYS.INVASIVE_HEART_PROCEDURE}
                    title='invasive heart procedure'/>&nbsp;avoided&nbsp;<span className='benefits-text'>
                    {
                      Number(avoidingHeartAttackInvasiveDetails.probability).toFixed(0) -
                      Number(avoidingHeartAttackConservativeDetails.probability).toFixed(0)
                    }
                  &nbsp;heart attacks for every 100 patients</span>&nbsp;like you compared to&nbsp;<Tooltip
                    id={GLOSSARY_KEYS.OPTIMAL_MEDICATION_MANAGEMENT}
                    title='optimal medication management'/>.
                </p>
              </div>
            </div>
          </div>
          {/* The below section is only visible on screen, not while printing */}
          <div className='grid-x text-left margin-vertical-1 hide-for-print'>
            <div className='cell bordered all-rounded-borders'>
              <details>
                <summary className='padding-2'>
                  <h3 className='info-color text-uppercase'>What does this look like?</h3>
                </summary>
                <AvoidingHeartAttackDetails
                  conservativeProb={Number(avoidingHeartAttackConservativeDetails.probability).toFixed(0)}
                  invasiveProb={Number(avoidingHeartAttackInvasiveDetails.probability).toFixed(0)}
                />
              </details>
            </div>
          </div>
          {/* The below section is only visible while printing */}
          <div className='margin-vertical-2 show-for-print text-left'>
            <AvoidingHeartAttackDetails
              conservativeProb={Number(avoidingHeartAttackConservativeDetails.probability).toFixed(0)}
              invasiveProb={Number(avoidingHeartAttackInvasiveDetails.probability).toFixed(0)}
            />
            <div className='padding-horizontal-2'>
              <AvoidingHeartAttackAddInfo/>
            </div>
          </div>
          {/* The below section is only visible on screen */}
          <div className='grid-x text-left margin-vertical-1 hide-for-print'>
            <div className='cell bordered all-rounded-borders'>
              <details>
                <summary className='padding-2'>
                  <h3 className='info-color text-uppercase'>
                    What is this information based on? (Show me the references)
                  </h3>
                </summary>
                <AvoidingHeartAttackReferences/>
              </details>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
